var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 42,
    viewBox: "0 0 82 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C13.9974 2.08312 14.8023 28.0136 27.6667 31C38.2749 33.4626 43.6466 19.4836 54.3333 21C65.9248 22.6447 69.6341 37.2114 81 41H1V1Z",
    fill: "#FEF3F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C13.9974 2.08312 14.8023 28.0136 27.6667 31C38.2749 33.4626 43.6466 19.4836 54.3333 21C65.9248 22.6447 69.6341 37.2114 81 41H1V1Z",
    fill: "url(#paint0_linear_8482_23177)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 41C69.6341 37.2114 65.9248 22.6447 54.3333 21C43.6466 19.4836 38.2749 33.4626 27.6667 31C14.8023 28.0136 13.9974 2.08312 1 1",
    stroke: "#F04438",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8482_23177",
    x1: 41,
    y1: 1,
    x2: 41,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartCritical);
export default __webpack_public_path__ + "static/media/chart-critical.c82d34c669b0de1b3d528fabc2abdd46.svg";
export { ForwardRef as ReactComponent };